/**
 * CallTypeIcon.tsx
 * Talkroute
 *
 * Created by Vel Genov on 1/25/19
 * Copyright (c) 2019 Talkroute. All right reserved.
 */

import React from "react";
import HangupIcon from "@resources/icons/status-hang-up.svg";
import MissedIcon from "@resources/icons/status-missed.svg";
import OutgoingIcon from "@resources/icons/status-outgoing.svg";
import AnsweredIcon from "@resources/icons/status-answered.svg";
import { IconButton } from "@material-ui/core";
import { CallStatus, CallType } from "@models/Callhistory.models";

const Wrapper = ({ children }) => <IconButton> {children}</IconButton>;

/**
 * Render a different icon based on the call type, and if we are hovering over it
 *
 * Inbound answered calls get no icon
 * Inbound calls that are missed or hangup do get icons - phone with X
 * Outbound calls get icon with arrow away from the phone
 *
 * @param clickable whether or not the icon should render with an IconButton wrapper
 * @param type the call type - inbound or outbound
 * @param callResult the result of a call - missed, hang up, etc.
 * @param hovering a boolean variable set to true if we are hovering over the component
 */
export default function showCallType(props) {
  const { type, callResult, hovering, clickable } = props;
  // This section will likely change and we will be using an external image
  const iconColor = hovering ? "opacity(0.5) drop-shadow(0 0 0 red)" : "none";

  if (type === CallType.INBOUND) {
    if (callResult === CallStatus.MISSED) {
      return clickable ? (
        <Wrapper>{showInboundMissedCall(iconColor)}</Wrapper>
      ) : (
        showInboundMissedCall(iconColor)
      );
    }

    if (callResult === CallStatus.HANGUP) {
      return clickable ? (
        <Wrapper>{showInboundHangUpCall(iconColor)}</Wrapper>
      ) : (
        showInboundHangUpCall(iconColor)
      );
    }

    if (callResult === CallStatus.ANSWERED) {
      return clickable ? (
        <Wrapper>{showAnsweredCall(iconColor)}</Wrapper>
      ) : (
        showAnsweredCall(iconColor)
      );
    }

    // Inbound calls get no icon
    return null;
  }

  // Outbound calls get icon with arrow away from the phone
  return clickable ? (
    <Wrapper>{showOutboundCall(iconColor)}</Wrapper>
  ) : (
    showOutboundCall(iconColor)
  );
}

/**
 * Show the inbound hang up call icon
 *
 * @param {*} iconColor the render color for the icon
 */
const showInboundHangUpCall = (iconColor = "none") => (
  <HangupIcon
    className="call-history-item-inbound-hangup-icon"
    style={{ filter: iconColor, fill: "var(--color-charcoal)", flexShrink: 0 }}
  />
);

/**
 * Show the inbound missed call icon
 *
 * @param {*} iconColor the render color for the icon
 */
const showInboundMissedCall = (iconColor = "none") => (
  <MissedIcon
    className="call-history-item-inbound-missed-icon"
    style={{ fill: "var(--color-charcoal)", flexShrink: 0 }}
  />
);

/**
 * Show the outbound call icon
 *
 * @param {*} iconColor the render color for the icon
 */
const showOutboundCall = (iconColor = "none") => (
  <OutgoingIcon
    className="call-history-item-outbound-icon"
    style={{ filter: iconColor, fill: "var(--color-charcoal)", flexShrink: 0 }}
  />
);

/**
 * Show the answered call icon
 *
 * @param {*} iconColor the render color for the icon
 */
 const showAnsweredCall = (iconColor = "none") => (
  <AnsweredIcon
    className="call-history-item-outbound-icon"
    style={{ filter: iconColor, fill: "var(--color-charcoal)", flexShrink: 0 }}
  />
);
